export const en = {
  "app.name": "Reelaivideo",
  "app.tagline": "AI-generated short video, under 60 seconds.",

  "nav.feed": "Feed",
  "nav.upload": "Upload",
  "nav.mine": "My videos",
  "nav.profile": "Profile",
  "nav.admin": "Moderation",
  "nav.login": "Sign in",
  "nav.register": "Create account",
  "nav.logout": "Sign out",
  "nav.menu": "Menu",

  "common.loading": "Loading",
  "common.retry": "Try again",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.saved": "Saved",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.edit": "Edit",
  "common.more": "Load more",
  "common.back": "Back",
  "common.optional": "optional",
  "common.copy": "Copy link",
  "common.copied": "Link copied",
  "common.theme": "Toggle theme",
  "common.language": "Change language",
  "common.refresh": "Refresh",
  "common.of": "of",
  "common.characters": "characters",
  "common.anonymous": "Guest",
  "common.empty": "Nothing here yet",
  "common.notFound": "Page not found",
  "common.notFoundHint": "The page you requested does not exist.",

  "auth.identifier": "Username or email",
  "auth.password": "Password",
  "auth.email": "Email",
  "auth.username": "Username",
  "auth.usernameHint": "3 to 32 characters: letters, digits, underscore or dot.",
  "auth.passwordHint":
    "At least 10 characters, mixing three of: lowercase, uppercase, digit, symbol.",
  "auth.loginTitle": "Welcome back",
  "auth.loginSubtitle": "Sign in to upload, like and manage your clips.",
  "auth.registerTitle": "Create your account",
  "auth.registerSubtitle": "Publish AI-generated clips in under a minute.",
  "auth.haveAccount": "Already have an account?",
  "auth.noAccount": "No account yet?",
  "auth.submitLogin": "Sign in",
  "auth.submitRegister": "Create account",
  "auth.working": "Please wait",
  "auth.strength.weak": "Weak",
  "auth.strength.fair": "Fair",
  "auth.strength.strong": "Strong",
  "auth.registered": "Account created. Signing you in.",
  "auth.guestCta": "Sign in to continue",
  "auth.guestHint": "This action needs an account.",
  "auth.sessions": "Active sessions",
  "auth.logoutEverywhere": "Sign out everywhere",

  "feed.latest": "Latest",
  "feed.popular": "Popular",
  "feed.empty": "No published videos yet.",
  "feed.emptyHint": "Be the first: upload a clip and publish it.",
  "feed.unmute": "Unmute",
  "feed.mute": "Mute",
  "feed.play": "Play",
  "feed.pause": "Pause",
  "feed.like": "Like",
  "feed.unlike": "Remove like",
  "feed.report": "Report",
  "feed.share": "Share",
  "feed.details": "Details",
  "feed.byAuthor": "Videos by {name}",
  "feed.clearAuthor": "Clear filter",
  "feed.scrollHint": "Scroll for the next clip",

  "video.views": "views",
  "video.likes": "likes",
  "video.duration": "Duration",
  "video.resolution": "Resolution",
  "video.size": "Size",
  "video.status": "Status",
  "video.uploaded": "Uploaded",
  "video.published": "Published",
  "video.codec": "Codec",
  "video.audio": "Audio",
  "video.audioYes": "Included",
  "video.audioNo": "Silent",
  "video.rejection": "Reason given by review",
  "video.openReports": "Open reports",
  "video.title": "Title",
  "video.description": "Description",
  "video.visible": "Visible in the feed",
  "video.hidden": "Hidden from the feed",
  "video.deleteConfirm": "Delete this video?",
  "video.deleteWarning": "The file and its statistics are removed. This cannot be undone.",
  "video.unavailable": "This video is not playable yet.",
  "video.pendingReview": "Waiting for review before it appears in the feed.",

  "status.UPLOADING": "Uploading",
  "status.VALIDATING": "Validating",
  "status.MODERATING": "Screening",
  "status.READY": "Ready",
  "status.PUBLISHED": "Published",
  "status.FLAGGED": "In review",
  "status.REJECTED": "Rejected",
  "status.DELETED": "Deleted",

  "mine.title": "My videos",
  "mine.subtitle": "Every clip you uploaded, in every state.",
  "mine.empty": "You have not uploaded anything yet.",
  "mine.publish": "Publish",
  "mine.unpublish": "Unpublish",

  "upload.title": "Upload a clip",
  "upload.subtitle": "The file goes straight to storage. Our API never touches the bytes.",
  "upload.drop": "Drag a video here",
  "upload.dropHint": "MP4, up to {size} and {seconds} seconds.",
  "upload.choose": "Choose a file",
  "upload.replace": "Choose another file",
  "upload.titleLabel": "Title",
  "upload.titlePlaceholder": "Give the clip a title",
  "upload.descLabel": "Description",
  "upload.descPlaceholder": "Add context, prompt or model used",
  "upload.publishNow": "Publish as soon as screening clears",
  "upload.submit": "Start upload",
  "upload.cancel": "Cancel upload",
  "upload.step.authorize": "Authorising",
  "upload.step.transfer": "Transferring",
  "upload.step.confirm": "Confirming",
  "upload.step.processing": "Processing",
  "upload.processing": "Validating and screening your clip",
  "upload.processingHint": "This usually takes a few seconds.",
  "upload.donePublished": "Published. It is live in the feed.",
  "upload.doneFlagged": "Held for manual review.",
  "upload.doneRejected": "Rejected by screening.",
  "upload.doneReady": "Ready. Publish it whenever you like.",
  "upload.another": "Upload another",
  "upload.viewVideo": "Open video",
  "upload.errTooLarge": "That file is {actual}. The limit is {limit}.",
  "upload.errTooLong": "That clip is {actual}s. The limit is {limit}s.",
  "upload.errType": "Only MP4 video is accepted.",
  "upload.errProbe": "The browser could not read that file as video.",
  "upload.requirements": "Requirements",

  "report.title": "Report this video",
  "report.subtitle": "A reviewer looks at every report.",
  "report.reason": "Reason",
  "report.detail": "Anything else we should know?",
  "report.submit": "Send report",
  "report.done": "Thank you. The report was recorded.",
  "report.reason.sexual_content": "Sexual content",
  "report.reason.violence": "Violence",
  "report.reason.hate_speech": "Hate speech",
  "report.reason.illegal_activity": "Illegal activity",
  "report.reason.self_harm": "Self-harm",
  "report.reason.child_safety": "Child safety",
  "report.reason.spam": "Spam",
  "report.reason.copyright": "Copyright",
  "report.reason.other": "Something else",

  "profile.joined": "Joined {date}",
  "profile.videos": "Videos",
  "profile.views": "Views",
  "profile.likes": "Likes",
  "profile.edit": "Edit profile",
  "profile.bio": "Bio",
  "profile.avatar": "Avatar URL",
  "profile.empty": "No published videos yet.",
  "profile.tabVideos": "Videos",
  "profile.tabJoinedCommunities": "Joined Communities",
  "profile.tabCreatedCommunities": "Created Communities",
  "profile.noJoinedCommunities": "You have not joined any communities yet.",
  "profile.noJoinedCommunitiesOther": "This user has not joined any communities yet.",
  "profile.noCreatedCommunities": "You have not created any communities yet.",
  "profile.noCreatedCommunitiesOther": "This user has not created any communities yet.",
  "profile.exploreCommunities": "Explore Communities",
  "profile.createCommunity": "Create Community",
  "profile.manageMembers": "Manage Members",
  "profile.pendingRequestsCount": "{count} pending request(s)",
  "profile.browseFeed": "Browse Feed",

  "admin.title": "Admin Dashboard",
  "admin.subtitle": "Platform governance, user management, and moderation.",
  "admin.tabOverview": "Overview",
  "admin.tabUsers": "Users",
  "admin.tabCommunities": "Communities",
  "admin.tabModeration": "Moderation Queue",
  "admin.totalStorage": "Total Storage Used",
  "admin.totalUsers": "Total Users",
  "admin.activeUsers": "Active Users",
  "admin.totalVideos": "Total Videos",
  "admin.totalCommunities": "Total Communities",
  "admin.searchUsers": "Search users by username or email...",
  "admin.searchCommunities": "Search communities by name or slug...",
  "admin.user": "User",
  "admin.email": "Email",
  "admin.joined": "Joined",
  "admin.videosCount": "Videos",
  "admin.storageUsed": "Storage Used",
  "admin.status": "Status",
  "admin.role": "Role",
  "admin.active": "Active",
  "admin.banned": "Banned",
  "admin.administrator": "Admin",
  "admin.standardUser": "User",
  "admin.banUser": "Ban User",
  "admin.unbanUser": "Unban User",
  "admin.makeAdmin": "Make Admin",
  "admin.removeAdmin": "Remove Admin",
  "admin.confirmBan": "Are you sure you want to ban @{username}? Their active sessions will be terminated immediately.",
  "admin.confirmUnban": "Are you sure you want to reactivate @{username}?",
  "admin.confirmDeleteCommunity": "Are you sure you want to delete community \"{name}\"? Any existing videos will be safely moved to the default public community.",
  "admin.communityName": "Community",
  "admin.accessType": "Access Type",
  "admin.createdBy": "Created By",
  "admin.members": "Members",
  "admin.actions": "Actions",
  "admin.delete": "Delete",
  "admin.noUsersFound": "No users found.",
  "admin.noCommunitiesFound": "No communities found.",
  "admin.userUpdated": "User updated successfully.",
  "admin.communityDeleted": "Community deleted successfully.",
  "admin.queueDepth": "In queue",
  "admin.clear": "Cleared",
  "admin.flagged": "Flagged",
  "admin.blocked": "Blocked",
  "admin.openReports": "Open reports",
  "admin.approve": "Approve",
  "admin.reject": "Reject",
  "admin.reason": "Reason shown to the owner",
  "admin.notes": "Internal notes",
  "admin.empty": "The queue is empty. Nothing to review.",
  "admin.frames": "Sampled frames",
  "admin.noFrames": "No frames were sampled.",
  "admin.provider": "Provider",
  "admin.score": "Score",
  "admin.label": "Top label",
  "admin.owner": "Owner",
  "admin.reports": "Reports",
  "admin.reviewed": "{action} — {status}",
  "admin.shortcuts": "Shortcuts: J and K to move, A to approve, R to reject.",
  "admin.forbidden": "This area is for administrators.",

  "error.generic": "Something went wrong.",
  "error.network": "Cannot reach the API. Is the backend running?",
  "error.rateLimited": "Too many requests. Try again in {seconds}s.",
  "error.notFound": "Not found.",
  "error.forbidden": "You do not have access to that.",
  "error.unauthorized": "Please sign in again.",

  "community.all": "All",
  "community.tabs": "Communities",
  "community.create": "Create Community",
  "community.new": "New Community",
  "community.name": "Community Name",
  "community.namePlaceholder": "e.g. Doctors, Architects, Cairo",
  "community.nameHint": "Up to 60 characters",
  "community.description": "Description",
  "community.descriptionPlaceholder": "What is this community about?",
  "community.created": "Community created successfully.",
  "community.select": "Community",
  "community.selectHint": "Choose which community this video belongs to.",
  "community.empty": "No videos in this community yet.",
  "community.emptyHint": "Be the first to post a video in this community!",

  "search.title": "Search",
  "search.tabVideos": "Videos",
  "search.tabCommunities": "Communities",
  "search.placeholder": "Search videos by title, description, or @creator...",
  "search.communitiesPlaceholder": "Search communities by name or description...",
  "search.uploadDate": "Upload Date",
  "search.from": "From Date",
  "search.to": "To Date",
  "search.allDates": "Any Time",
  "search.sort": "Sort By",
  "search.sort.latest": "Newest Upload",
  "search.sort.oldest": "Oldest Upload",
  "search.sort.popular": "Most Popular",
  "search.results": "Search Results",
  "search.noResults": "No videos found.",
  "search.noResultsHint": "Try searching with different keywords or date filters.",
  "search.noCommunities": "No communities found.",
  "search.noCommunitiesHint": "Try searching with different keywords.",
  "search.browseCommunity": "Browse",
  "search.videoCount": "videos",
  "search.allCommunities": "All Communities",
  "search.clear": "Clear Search",

  "video.audience": "Audience",
  "video.audience.public": "Public",
  "video.audience.publicHint": "Anyone, signed in or not, can watch.",
  "video.audience.private": "Private",
  "video.audience.privateHint": "Only you can watch.",
  "video.audience.restricted": "Restricted",
  "video.audience.restrictedHint": "Only specific users you add can watch.",
  "video.allowedUsers": "Allowed Usernames",
  "video.allowedUsersHint": "Comma-separated list of usernames who may watch.",
  "video.allowedUsersRequired": "Please specify at least one username for restricted audience.",
  "video.community": "Community",

  "community.privacy": "Community Privacy",
  "community.access.public": "Public",
  "community.access.publicHint": "Anyone, signed in or not, can browse and watch videos.",
  "community.access.private": "Private",
  "community.access.privateHint": "Only you can see this community and its videos.",
  "community.access.restricted": "Restricted",
  "community.access.restrictedHint": "Only approved members can watch videos. Users can request to join.",
  "community.initialMembers": "Initial Members (Optional)",
  "community.initialMembersHint": "Comma-separated usernames to add immediately.",
  "community.joinRequest": "Request to Join",
  "community.joinRequested": "Join Request Pending",
  "community.member": "Member",
  "community.owner": "Owner",
  "community.manageMembers": "Manage Members",
  "community.pendingRequests": "Pending Requests",
  "community.membersList": "Members List",
  "community.addMember": "Add Member",
  "community.addMemberPlaceholder": "Enter username to add...",
  "community.add": "Add",
  "community.remove": "Remove",
  "community.kickOff": "Kick off",
  "community.memberRemoved": "Member has been removed from this community.",
  "community.approve": "Approve",
  "community.reject": "Reject",
  "community.restrictedBanner": "This community is restricted to approved members.",
  "community.restrictedPrompt": "Request to join to view videos published in this community.",

  "feed.comments": "Comments",
  "comments.title": "Comments",
  "comments.placeholder": "Write a comment...",
  "comments.submit": "Post",
  "comments.posting": "Posting...",
  "comments.empty": "No comments yet. Be the first to comment!",
  "comments.guestHint": "Sign in to leave a comment.",
  "comments.delete": "Delete comment",
  "comments.deleteConfirm": "Are you sure you want to delete this comment?",
  "comments.count": "comments",
  "comments.loadMore": "Load more comments",
} as const;

export type TranslationKey = keyof typeof en;
